var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71875 11.4583C1.71875 12.4076 2.48826 13.1771 3.4375 13.1771L3.4375 10.3125C3.4375 9.04685 4.46351 8.02083 5.72917 8.02083H9.16667C10.4323 8.02083 11.4583 9.04685 11.4583 10.3125V13.1771C12.4076 13.1771 13.1771 12.4076 13.1771 11.4583V5.19697C13.1771 4.89307 13.0564 4.60163 12.8415 4.38674L10.5091 2.05436C10.2942 1.83947 10.0028 1.71875 9.69887 1.71875H5.15625V2.86458C5.15625 3.181 5.41275 3.4375 5.72917 3.4375H9.16667C9.64129 3.4375 10.026 3.82226 10.026 4.29688C10.026 4.77149 9.64129 5.15625 9.16667 5.15625H5.72917C4.46351 5.15625 3.4375 4.13024 3.4375 2.86458V1.71875C2.48826 1.71875 1.71875 2.48826 1.71875 3.4375V11.4583ZM0 11.4583C0 13.3568 1.53902 14.8958 3.4375 14.8958H5.15625H9.73958H11.4583C13.3568 14.8958 14.8958 13.3568 14.8958 11.4583V5.19697C14.8958 4.43723 14.594 3.70861 14.0568 3.1714L11.7244 0.839017C11.1872 0.301803 10.4586 0 9.69887 0H3.4375C1.53902 0 0 1.53902 0 3.4375V11.4583ZM9.73958 10.3125V13.1771H5.15625V10.3125C5.15625 9.99609 5.41275 9.73958 5.72917 9.73958H9.16667C9.48308 9.73958 9.73958 9.99609 9.73958 10.3125Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4B629E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.8252653dad1f579f20edb8a47369a8ce.svg";
export { ForwardRef as ReactComponent };